/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Tutorial_DescInputs */

const en_fc_home_paths_tutorial_desc = /** @type {(inputs: Fc_Home_Paths_Tutorial_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn to import clips, arrange a timeline, trim, add sound and export your first video.`)
};

/**
* | output |
* | --- |
* | "Learn to import clips, arrange a timeline, trim, add sound and export your first video." |
*
* @param {Fc_Home_Paths_Tutorial_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_tutorial_desc = /** @type {((inputs?: Fc_Home_Paths_Tutorial_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Tutorial_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_tutorial_desc(inputs)
});
export { fc_home_paths_tutorial_desc as "fc.home.paths.tutorial.desc" }